export const getNumberFormatter = (format, precesion) => {
  return number => {
    if (number) {
      return number.toLocaleString(format, {
        minimumFractionDigits: precesion || 2,
        maximumFractionDigits: precesion || 2
      });
    } else {
      return "0.00";
    }
  };
};
